import { VhcRecordBaseElements } from './components/base-elements';
import { VhcRecordDescription } from './description';
import { Col, Row } from 'react-bootstrap';

export const VhcRecordDefaultForm = () => {
  return (
    <Row>
      <Col>
        <VhcRecordDescription />
        <VhcRecordBaseElements />
      </Col>
    </Row>
  );
};
